import { clsx } from 'clsx';

import { Box } from '../../box/box';
import { Link } from '../../link/link';
import { Loading } from '../../loading/loading';
import { Typography } from '../../typography/typography';
import type { TypeAheadResultsProps } from '../typeAhead.types';
import { useTypeAheadContext } from '../typeAheadContext';
import { ResultListItem } from './resultListItem';

import styles from './typeAheadResults.module.css';

export function TypeAheadResults({
  className,
  'data-testid': testId,
  hideDeselect,
  id,
  popoverFooter,
  preResultsText,
  style,
}: TypeAheadResultsProps) {
  const {
    listAriaLabel,
    optionType,
    onSelection,
    loading,
    options,
    width,
    query,
  } = useTypeAheadContext();

  return loading ? (
    <Box height={24} position="relative" mb={16} mt={12} width="100%">
      <Loading />
    </Box>
  ) : options && options.length > 0 ? (
    <Box
      ariaLabel={listAriaLabel}
      className={clsx(className, styles['typeAheadResults_list'])}
      data-testid={testId}
      id={id}
      maxHeight={420}
      style={style}
      width={width}
    >
      {options?.map((option, index) => (
        <ResultListItem
          key={index}
          label={option.label}
          subLabel={option.subLabel}
        />
      ))}
      {optionType === 'checkbox' && !hideDeselect && (
        <Link mx={24} my={8} onClick={() => onSelection && onSelection([])}>
          Deselect all
        </Link>
      )}
      {popoverFooter && popoverFooter}
    </Box>
  ) : (
    <Box
      ariaLabel={listAriaLabel}
      className={clsx(className, styles['typeAheadResults_list'])}
      id={id}
      maxHeight={420}
      width={width}
    >
      <Typography mx={24} color="text-light">
        {!query?.length && preResultsText ? preResultsText : 'No Results'}
      </Typography>
      {popoverFooter && popoverFooter}
    </Box>
  );
}
